// This component fetches and displays a carousel of trending products using Algolia's `useTrendingItems` hook.
// It shows a loading spinner while fetching data and renders results with `AlgoliaRecommendationCarousel`.
// Useful for highlighting popular or top-selling products.

import React from 'react';
import { useTrendingItems } from 'react-instantsearch-core';
import Loading from 'components/commercetools-ui/atoms/loading';
import { P2Badge } from '../product-list-algolia/types';

import ProductTileSlider from '../../ProductTile-Slider';

function TrendingItems({
  title,
  p1BadgeData,
  p2BadgeData,
  queryParameters,
}: {
  title?: string;
  p1BadgeData: any;
  p2BadgeData: P2Badge[];
  queryParameters?: string;
}) {
  return (
    <AlgoliaRecommendationCarouselWrapper
      title={title}
      p1BadgeData={p1BadgeData}
      p2BadgeData={p2BadgeData}
      queryParameters={queryParameters}
    />
  );
}

function AlgoliaRecommendationCarouselWrapperComponent({
  title,
  p1BadgeData,
  p2BadgeData,
  queryParameters,
}: {
  title?: string;
  p1BadgeData: any;
  p2BadgeData: P2Badge[];
  queryParameters?: string;
}) {
  let raw = queryParameters;
  if (raw?.startsWith('"') && raw?.endsWith('"')) {
    raw = raw?.slice(1, -1);
  }
  const cleanedFilter = raw?.replace(/\\"/g, '"');
  const result =
    useTrendingItems({
      queryParameters: {
        filters: cleanedFilter,
      },
    }) || {};

  const items = result?.items;
  return (
    <>
      {/*     
      <AlgoliaRecommendationCarousel
        title={title || 'Trending Items'}
        p1BadgeData={p1BadgeData}
        p2BadgeData={p2BadgeData}
        items={items}
      /> */}
      {items && (
        <ProductTileSlider
          title={title || 'Trending Items'}
          p1BadgeData={p1BadgeData}
          p2BadgeData={p2BadgeData}
          items={items}
        />
      )}
    </>
  );
}

const AlgoliaRecommendationCarouselWrapper = React.memo(AlgoliaRecommendationCarouselWrapperComponent);
AlgoliaRecommendationCarouselWrapper.displayName = 'AlgoliaRecommendationCarouselWrapper';

export default TrendingItems;
